<template>
	<div>
		<div class=" row">
			<div class="aside col-6">
				<vue-nestable  :maxDepth="maxDepth" v-model="nestableItems1" >
					<vue-nestable-handle
					slot-scope="{ item }"

					:item="item">
					<i :class="{ colorNew: item.id == '111' }" class="fa fa-link" aria-hidden="true"></i> {{ item.title }}  

					<i  v-if="productPage && item.parent_id != 0" @click="exportCategoryId(item.id)" :class="{colorNew: item.id == categoryActive}" class="icon-nastable fa fa-check" aria-hidden="true"></i>  

					<i v-if="toMany && item.parent_id != 0" @click="exportCategories(item)" :class="{ colorNew: item.checked == true }" class="icon-nastable fa fa-check" aria-hidden="true"></i>

					<i  v-if="!productPage && !toMany" @click="changeStatus(item.id)" :class="{colorNew: item.status }" class=" icon-nastable fa fa-power-off" aria-hidden="true"></i> 
					<router-link  v-if="!productPage && !toMany" :to="{ name: 'shop-category-edit', params: { id: item.id }  }"><i class=" edit-icon icon-nastable fa fa-pencil-square-o" aria-hidden="true"></i></router-link>
					
				</vue-nestable-handle>
			</vue-nestable>


		</div>


	</div>
</div>
</template>
<!-- :class="{ colorNew: colorNew}" -->
<script>
	import axios from 'axios'

	import { VueNestable, VueNestableHandle } from 'vue-nestable'

	export default {
		name: 'sortable-category',
		props: {
			title: {
				type: String
			},
			productPage: {
				type: Boolean,
				default: false
			},
			toMany: {
				type: Boolean,
				default: false
			},
			subcategory_id: {
				type: Number,
				
			},
			categoriesChecked: {
				type: Array,
				// default:false
			}


		},
		components: {
			VueNestable,
			VueNestableHandle,

		},

		created() {
			axios.get(this.$store.getters.getDomainName+'shop/category')
			.then(response => {

				this.nestableItems1 = response.data

				for (var i = this.nestableItems1.length - 1; i >= 0; i--) {

					for (var j = this.nestableItems1[i].children.length - 1; j >= 0; j--) {

						for (var k = this.categoriesChecked.length - 1; k >= 0; k--) {

							if(this.nestableItems1[i].children[j].id == this.categoriesChecked[k]) {
								this.nestableItems1[i].children[j].checked = true
							}
						}
					}
				}
				

				if(this.$route.name == 'shop-category-create') {
					this.nestableItems1.push({
						id:111,
						title: 'wdwdwd',
						children: [],
					})

				}

			})
			.catch(error => {

			})

			eventBus.$on('exportSubcategory', data => {
				this.categoryActive = data
			})
		},
		beforeDestroy() {
			eventBus.$off('exportSubcategory')
		},
		data() {
			return {
				categoryActive: 0,
				maxDepth: 2,
				newCategory: '111111',
				newTitle: '',
				exp: [],

				nestableItems1: [],

			}
		},
		
		

		methods: {

			changeStatus(id) {
				axios.get(this.$store.getters.getDomainName+'shop/category/change/status/'+id)
				.then(response => {
					for (var i = 0; i < this.nestableItems1.length; i++) {

						if(id == this.nestableItems1[i]['id']) {
							this.nestableItems1[i]['status'] = response.data

							
						}
						for(var j = 0; j < this.nestableItems1[i].children.length;j++) {
							console.log(this.nestableItems1[i].children[j])

							//console.log(this.nestableItems1[i])
							if (this.nestableItems1[i].children[j].id == id) {
								this.nestableItems1[i].children[j].status = response.data
							}
						}
					}

				})
				.catch(error => {

				})
			},
			exportCategoryId(id) {
				this.categoryActive = id
				this.$emit('exportCategoryId', id)

			},
			exportCategories(item) {
				console.log(item)
				item.checked == true ?  item.checked = false : item.checked = true

				var exp = this.nestableItems1.filter(item => item.checked);

				// console.log(exp)

				this.$emit('exportCategories', this.nestableItems1)

				// exportCategories
			}
		},
		watch: {
			categoriesChecked(data) {
				for (var i = data.length - 1; i >= 0; i--) {
					console.log(this.nestableItems1)
					for (var j = this.nestableItems1.length - 1; j >= 0; j--) {
						this.nestableItems1[j].checked = true
					}
				}
			},
			subcategory_id(value) {
				this.categoryActive = value
			},
			nestableItems1() {
				this.$emit('exportCategory', this.nestableItems1)
			},
			title(value) {
				for (var i = 0; i < this.nestableItems1.length; i++) {
					if(this.nestableItems1[i].children.length > 0) {
						console.log(this.nestableItems1[i].children.length)

						for(var j = 0; j < this.nestableItems1[i].children.length;j++) {

							if (this.nestableItems1[i].children[j].id == 111) {
								this.nestableItems1[i].children[j].title = this.title
							}
						}
					}

					if (this.nestableItems1[i].id == 111) {

						this.nestableItems1[i].title = this.title

					}

				}

				//console.log(this.nestableItems1.filter(item => item.id)== 5767688)
				var el = this.nestableItems1.findIndex(x => x.id === 111)
				//console.log(el)

				this.nestableItems1
				this.newTitle = value
				

			}
		},
		computed: {
			colorNew() {
				return this.nestableItems1[0] ? true : false
			}
		},
		
	}
</script>

<style>
.icon-nastable {
	cursor:pointer!important;
	margin-top: 3px;
	float: right;
	font-size: 13px;
}
.colorNew {
	color:#42b983;

}
.color-new-category {
	color:#42b983;
}
.title-nestable {
	font-size: 18px;
}
.blue-text-color {
	color: #415ad4;
}
.purple-text-color {
	color: #b43ceb;
}
.red-text-color {
	color: #e13a3a;
}
.nestable {
	position: relative;
	padding:  20px 50px;
}
.nestable .nestable-list {
	margin: 0;
	padding: 0 0 0 40px;
	list-style-type: none;
}
.nestable > .nestable-list {
	padding: 0;
}
.nestable-item,
.nestable-item-copy {
	margin: 10px 0 0;
}
.nestable-item:first-child,
.nestable-item-copy:first-child {
	margin-top: 0;
}
.nestable-item .nestable-list,
.nestable-item-copy .nestable-list {
	margin-top: 10px;
}
.nestable-item {
	position: relative;
}
.nestable-item.is-dragging .nestable-list {
	pointer-events: none;
}
.nestable-item.is-dragging * {
	opacity: 0;
	filter: alpha(opacity=0);
}
.nestable-item.is-dragging:before {
	content: ' ';
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(106, 127, 233, 0.274);
	border: 1px dashed rgb(73, 100, 241);
	-webkit-border-radius: 5px;
	border-radius: 5px;
}
.nestable-item {
	padding: 5px;
	width: 300px;
	background: #fff;
	border: 1px dotted #ccc;
	border-radius: 4px;
}
.nestable-drag-layer {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 100;
	pointer-events: none;
}
.nestable-drag-layer > .nestable-list {
	position: absolute;
	top: 0;
	left: 0;
	padding: 0;
	background-color: rgba(106, 127, 233, 0.274);
}
.nestable [draggable="true"] {
	cursor: move;
}
.nestable-handle {
	display: inline;
	font-size:13px;
}
.edit-icon {
	color:#777;
	margin-right: 5px;
}

</style>


// WEBPACK FOOTER //
// src/components/app_modules/SortableCategory.vue